module.exports = __webpack_public_path__ + "static/media/Screenshot_1-thumb.fc6dee8b.png";